import React, {Component, useState} from 'react';
import { withRouter } from 'react-router-dom';
import { RAIL_REVIEW_PATH } from '../../../../constants/URLconstants';
import {
  setItemBySession,
  itemType
} from 'MMT-UI/storages/client/sessionStorage';
import { STORAGE_CONSTANTS } from '../../../../constants/TrainConstants';

const VerificationCompleted = (props) => {
  const [ textCopied, setTextCopy] = useState(false);

  const copyText = () => {
    setTextCopy(true);
    window.navigator.clipboard.writeText(props.userName);
  };

  const updateUserId = () => {
    const { userName, reviewData } = props;
    setItemBySession(
      STORAGE_CONSTANTS.VERIFIED_USER_ID,
      userName,
      { isPiiData: true, shouldStringifyJson: true },
      itemType.ES
    );
    props.toggleChoice('regFlag');
    if (reviewData) {
      props.history.replace(RAIL_REVIEW_PATH, reviewData);
    } else {
      props.history.goBack();
    }
  };

    const { userName } = props;
    return (
      <div className="textCenter appendTop120">
        <p className="accountCreatedSuccessIcon" />
        <p className="font24 latoBold blackText appendBottom10">
                    IRCTC account created
        </p>
        <p className="defaultGreyText appendBottom10">
                    Email address and mobile number verified!
        </p>
        <p className="font12 defaultGreyText appendBottom20">
                    Continue booking train tickets with your new IRCTC username
        </p>
        <p className="copyCode makeFlex spaceBetween hrtlCenter">
          <span className="defaultGreyText">
            {userName}
          </span>
          {!textCopied && (
            <a
              className="makeFlex column hrtlCenter"
              onClick={copyText}
            >
              <span className="copyIcon railSprite" />
              <span className="latoBold font8">Copy</span>
            </a>
          )}
          {textCopied && (
            <span className="font16 latoBold deepskyBlueText">
                            Copied
            </span>
          )}
        </p>
        <p className="continueBookingLink font16 latoBlack">
          <a onClick={updateUserId}>continue booking</a>
        </p>
      </div>
    );
  }

export default withRouter(VerificationCompleted);
